import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';

export const ButtonContainer = styled(Row)`
  background-color: ${({ theme }) => theme.colors.white};
  width: 150px;
  border-radius: 4px;
`;

export const ModalContainer = styled(Column)`
  width: 620px;
  max-height: 80vh;
  overflow-y: auto;
`;

export const AddCommentColumn = styled(Column)`
  flex: 1;
`;
